<template>
  <div class="page-main flex-page">
    <div
      v-if="!lodash.isEmpty(subscription)"
      ref="mainContent"
      class="main-content"
      @scroll="contentScroll"
    >
      <!-- Trial Customer -->
      <Trial v-if="subscription.status === 'trial'"></Trial>

      <!-- Active Customer -->
      <Active v-if="subscription.status === 'active'"></Active>
    </div>

    <!--Pre Loader-->
    <PreLoader v-else :show="true" class="main-content"></PreLoader>
  </div>
</template>

<script>
// Libraries
import _ from "lodash";

// Components
import Trial from "@/components/apps/Translations/Home/Trial";
import Active from "@/components/apps/Translations/Home/Active";
import PreLoader from "@/components/loaders/PreLoader";

// Defaults
import { APP_NAMES } from "@/mixins/Variables";

// Services
import { TranslationsAppService } from "@/services";
const { CompanyService } = TranslationsAppService;

export default {
  name: "TranslationsHome",
  data() {
    return {
      lodash: _,
      showOptions: {
        headerShadow: false,
        unsavedChanges: false,
        lineLoader: false,
        disableButton: true,
      },
      status: {
        show: false,
        status: "success",
        title: "Widget theme saved",
      },
    };
  },
  props: {},
  components: {
    Active,
    Trial,
    PreLoader,
  },
  computed: {
    company() {
      return this.$store.getters.company;
    },
    selectedApp() {
      return this.$store.getters.selectedApp;
    },
    subscription() {
      return this.selectedApp.subscription;
    },
  },
  watch: {},
  async created() {
    await this.initApp();
  },
  methods: {
    // Initialise the app
    async initApp() {
      if (_.isEmpty(this.selectedApp)) {
        const data = { companyId: this.company._id };
        const response = await CompanyService.GetCompany(data);

        this.$store.commit("updateSelectedApp", {
          appName: APP_NAMES.translations,
          ...response.data,
        });
      }
    },

    // Event on scroll
    contentScroll() {
      const scrollTop = this.$refs.mainContent.scrollTop;

      // Check if header needs shadow
      if (scrollTop > 0) this.showOptions.headerShadow = true;
      else this.showOptions.headerShadow = false;
    },
  },
};
</script>

<style scoped lang="scss">
.insights-main {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  overflow-y: scroll;
  padding: 1.5rem 1rem 0;
  flex: 1;
}

.page-loader-wrapper {
  margin-top: 2rem;
}

::v-deep .line-loader {
  position: fixed;
  z-index: 101;
  bottom: 0;
  left: 0;
}

.show-shadow {
  box-shadow: 0 0.5rem 0.7rem -0.5rem $boxShadowColor;
}

.pre-loader-wrapper {
  flex: 1;
  margin: 5rem;

  ::v-deep {
    .buffer-line {
      width: auto;
    }
    .buffer-category {
      display: none;
    }

    .pre-loader:first-child {
      margin-bottom: 2rem;
      .buffer-category {
        display: block;
      }
    }
  }
}

::v-deep {
  .line-loader {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
  }

  .field-item {
    margin-bottom: 0;
  }

  .field-title {
    display: block;
    font-size: $smallestFontSize;
    text-align: right;
    margin-right: 0.5rem;
  }

  .dropdown-info-wrapper {
    margin-top: -0.5rem;
    background-color: $blackColor;

    .field-placeholder {
      font-size: $smallFontSize;
      color: darken($whiteColor, 10%) !important;
      width: max-content;
      margin-right: 1.5rem;
    }

    .unicon svg {
      fill: darken($whiteColor, 30%);
    }
  }
}
</style>
